import {
  IActionSetCookiePolicyHtml,
  SET_COOKIE_POLICY_HTML,
} from '../types/cookiePolicy';

export const setCookiePolicyHtml = (
  html: string
): IActionSetCookiePolicyHtml => ({
  type: SET_COOKIE_POLICY_HTML,
  payload: html,
});

export const openCookieSettings = (): void => {
  document.getElementById('cookie-settings-link')?.click();
};
